<template>
  <div>
    <!-- banner -->
    <Sbanner :detailInfo="detailOne" v-if="detailOne && detailOne.id" />

    <div class="program-detail">
      <div class="container" style="min-height:60vh">
        <div class="loading-area" v-if="loading">
          <loading-circle></loading-circle>
        </div>
        <div class="program-detail-top " :class="{ 'unfold': slideUnfold }" v-if="detailOne">
          <div class="top-left" v-if="!noRight">
            <div class="fold-btn" @click="hideInfo"></div>
            <div class="source-cate">
              <span :class="{ 'active': curSourceType == '视频' }" v-if="hasVideo"
                @click="changeSourceType('视频')">视频</span>
              <span :class="{ 'active': curSourceType == '图集' }" v-if="detailOne.pic_list"
                @click="changeSourceType('图集')">图集</span>
              <span :class="{ 'active': curSourceType == '音频' }" v-if="detailOne.mp3_path"
                @click="changeSourceType('音频')">音频</span>
            </div>
            <!-- 视频 -->
            <div class="source-video" v-if="hasVideo" v-show="curSourceType == '视频'" :loading="videoLoading">
              <!-- nodownload nofullscreen noremote footbar  -->
              <video id="myVideo" preload controls controlsList="nodownload  noremote footbar" playsinline="playsinline"
                webkit-playsinline="webkit-playsinline" x5-video-player-type="h5" :poster="detailOne.cover_img" :src="detailOne.mp4_path"></video>
            </div>
            <!-- 图集 -->
            <div class="source-gallery" v-if="detailPicList && detailPicList.length > 0" v-show="curSourceType == '图集'">
              <full-gallery :info="detailPicList" showpath="" ref="gallery" />
            </div>
            <!-- 音频 -->
            <div class="source-audio" v-if="detailOne.mp3_path" v-show="curSourceType == '音频'">
              <div class="audio-box">
                <div class="audio-b" :class="{ 'active': audioPlay }" @click="changeAudioState">
                  <img :src="audioB" alt="">
                </div>
                <div class="audio-pic">
                  <div class="audio-pic-box" :class="{ 'active': audioPlay }" @click="changeAudioState">
                    <img :src="defaultAudioCover" alt="">
                  </div>
                  <div class="audio-btns" @click="changeAudioState">
                    <span class="iconfont icon-video_fill" v-if="!audioPlay"></span>
                    <span class="iconfont icon-pause-circle-fill" v-else></span>
                  </div>

                </div>

                <div class="audio-time" v-if="!isIe">
                  <span>{{ parseInt(audioCurrentTime) | formatTime }}</span>
                  <span>{{ parseInt(audioDuration) | formatTime }}</span>
                </div>
                <div class="audio-progress-new" v-if="!isIe">
                  <input type="range" name="" id="slider" class="ne-range " ref="audioWidto" :value="audioPercent || 0"
                    max="100" @change="changeAudio" :style="{ backgroundSize: audioPercent + '% 100%' }" />
                </div>

                <audio style="height: 0" id="bgm" preload="auto" :src="detailOne.mp3_path" loop
                  @durationchange='audioChange' @timeupdate="updateTime"></audio>
              </div>
            </div>
            <div class="source-cover" :style="{ backgroundImage: 'url(' + detailOne.cover_img + ')' }"
              v-if="curSourceType == '封面'">
            </div>
          </div>
          <div class="top-left" v-else>
            <div class="no-right">
              <img :src="detailOne.cover_img" alt="" class="coverImg">
              <NoRightText :tempRoute="tempRoute" />
            </div>
          </div>
          <div class="top-right flex-column">
            <div class="names">
              <h3>{{ detailOne.name }}</h3>
              <p v-if="type_name || detailOne.type_tag_name">
                <span v-if="type_name">{{ type_name }}</span>
                <template v-if="mulTypeTag && mulTypeTag.length > 0">
                  <span v-for="item in mulTypeTag" v-if="item.name != type_name">
                    <em>{{ item.name }}：</em>
                    <em v-if="item.children">{{ item.children }}</em>
                  </span>
                </template>
                <span v-else-if="detailOne.type_tag_name && detailOne.type_tag_name != type_name">{{
      detailOne.type_tag_name |
      formatStandardSep }}</span>
                <!-- <em v-else-if="mulTypeTag && mulTypeTag.length==1" v-for="item in mulTypeTag">
                  <span >{{item.name}}</span>
                  <span >{{item.children}}</span>
                </em>
                 -->
              </p>
            </div>
            <div class="subs flex-bd">
              <div class="srollbox">
                <template v-for="item in otherInfo">
                  <!-- <p><span>{{item.artist_typename}}:</span> <em @click="goArtist(item.artist_id)">{{item.artist_name}}</em> </p> -->
                  <p>
                    <span>{{ item.artist_typename }}:</span>
                    <i>
                      <template v-for="(subItem, subIndex) in item.artist_name">
                        <em :class="{ 'light': subItem.isrc == 1 }"
                          @click="subItem.isrc == 1 ? goArtist(subItem.artist_id) : ''" :title="subItem.artist_name">
                          {{ subItem.artist_name }}{{ subIndex < item.artist_name.length - 1 ? ' 、' : "" }} </em>
                      </template>
                    </i>
                  </p>
                </template>
                <template v-for="(item, index) in literatures">
                  <p :key="index" @click="toLiterature(item.id)">
                    <span>{{ item.typeName }}:</span>
                    <label class="cl-red">{{ item.title }}</label>
                  </p>
                </template>
              </div>
            </div>

            <div class="prize" :class="detailOne.award ? '' : 'noPrice'">
              <p>
                <em @click="goActivity(detailOne.activity_id)">{{ detailOne.activity_name }}</em>
                <span v-if="detailOne.award">{{ detailOne.award }}</span>
              </p>
            </div>
          </div>
        </div>

        <div class="program-detail-content" v-if="detailOne">
          <div class="introduce">
            <div class="title flex">
              <!-- <p class="name">{{detailOne.name}}</p> -->
              <h3>{{ detailOne.name }}</h3>
              <!--  v-if="userInfo &&  userInfo.permissions && userInfo.permissions.indexOf('2')>=0 && detailOne.mp4_path"  -->
              <div class="downloadInfo flex">
                <span class="download flex" @click="download(detailOne.mp4_path, detailOne.name)"
                  v-if="userInfo && userInfo.permissions && userInfo.permissions.indexOf('2') >= 0 && detailOne.mp4_path">
                  <i class="iconfont icon-download-2-line"></i>
                  <i>{{ detailOne.file_size }}MB，</i>
                </span>

                <span>{{ detailOne.download_count || 0 }} 次下载</span>
              </div>
              <!-- <p class="lookCount">
                <span>{{detailOne.look_count}} 次浏览</span>
              </p> -->
              <Actions v-if="detailOne.id" banner="3" :view="detailOne.look_count" :collect="detailOne.collect_count"
                :like="detailOne.like_count" :row="detailOne" />

            </div>
            <div class="intro-sub">
              <p class="label">
                <template v-for="(item, index) in detailOne.keywords">
                  <span :key="index" v-if="detailOne.keywords">{{ item }}</span>
                </template>
              </p>
            </div>
            <div class="intro-txt">
              <div class="intro-txt-c" v-html="detailOne.introduce"></div>
              <div>
                <p v-if="detailOne.show_persons">表演人数：{{ detailOne.show_persons }}</p>
                <p v-if="detailOne.performance_unit">表演单位：{{ detailOne.performance_unit }}</p>
                <p v-if="detailOne.show_address">演出地点：{{ detailOne.show_address }}</p>
                <p v-if="detailOne.show_time">演出时间：{{ detailOne.show_time | formatStandardDate }}</p>
                <p v-if="detailOne.selected_unit">报送单位：{{ detailOne.selected_unit | formatStandardSep }}</p>
              </div>
            </div>
          </div>
          <div class="relate">
            <h3 class="cate2">
              <p :class="{ 'active': relateType == '0' }" v-if="relateProgramlist.length > 0"
                @click="changeRelateType(0)">相关作品
              </p>
              <!-- <p :class="{'active':relateType=='1'}" v-if="relateAwardList.length>0" @click="changeRelateType(1)">获奖作品</p> -->
              <p :class="{ 'active': relateType == '2' }" v-if="relateActivitylist.length > 0"
                @click="changeRelateType(2)">专题活动
              </p>
            </h3>
            <div class="relate-con">
              <div class="programlist-show" v-show="relateType == '0'">
                <template v-for="item in relateProgramlist">
                  <ProgramItem :item="item" :showpath="showpath" access="0" />
                </template>
              </div>
              <!-- <div class="award-list"  v-show="relateType=='1'">
                <template v-for="item in relateAwardList">
                  <AwardItem :item="item"  :showpath="showpath" />
                </template>
              </div> -->
              <div class="hd-list" v-show="relateType == '2'">
                <template v-for="item in relateActivitylist">
                  <activity-item :item="item" :showpath="showpath" />
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Sbanner from '@/components/sbanner.vue'
import audioB from '@/assets/images/audio-b.png'
import defaultAudioCover from '@/assets/images/audio_cover.png'
import ProgramItem from '@/components/listModel/programItem.vue'
import AwardItem from '@/components/listModel/awardItem.vue'
import ActivityItem from '@/components/listModel/activityItem.vue'
import FullGallery from '@/components/common/fullGallery.vue'
import NoRightText from '@/components/NoRightText.vue'
import colums from '@/colums/colums'
import { mapState, mapMutations } from 'vuex'
import LoadingCircle from '@/components/common/loadingCircle.vue'
import { downloadZip } from "@/utils/downloadZip"
import Actions from '@/pages/exhibit/components/Actions.vue'
import { download } from '@/utils/download'
export default {
  name: 'programDetail',
  props: {
    msg: String
  },
  components: {
    Sbanner, ProgramItem, AwardItem,
    ActivityItem,
    FullGallery,
    LoadingCircle,
    Actions,
    NoRightText
  },
  data() {
    return {
      curid: -1,
      programColum: colums.jmkcate,
      literatureColum: colums.literatureCate,
      defaultAudioCover,
      audioB,
      audioCover: '',
      audioPlay: false,
      showpath: '',
      detailOne: null,
      detailPicList: [],
      otherInfo: [],
      slideUnfold: false,
      relateAwardList: [],
      relateActivitylist: [],
      relateProgramlist: [],
      relateType: 0,
      curSourceType: '视频',
      audioInfo: {},
      audioDuration: 0,
      audioCurrentTime: 0,
      errorMsg: '',
      noRight: false,
      loading: "true",
      mulTypeTag: null,
      isIe: false,
      literatures: [],
      hasVideo: false,
      videoLoading: false,
    }
  },
  computed: {
    ...mapState(['userInfo']),
    type_name() {
      if (this.detailOne) {
        let obj = this.programColum.find(t => { return t.id == this.detailOne.type_id })
        let typeName = obj.name || '';
        this.getSecondLabel(obj)
        // this.programColum.forEach(item=>{
        //   if(this.detailOne.type_id == item.id){
        //     typeName = item.name
        //   }
        // })
        return typeName
      }
    },
    audioPercent() {
      let percent = Math.ceil((this.audioCurrentTime / this.audioDuration).toFixed(4) * 100);
      return percent;
    }
  },
  mounted() {
    const ua = window.navigator.userAgent;
    this.isIe = ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1;

    // console.log( this.$route);
    this.tempRoute = this.$route.path.replace(/\//g, '-')
    let curid = this.$route.params.id;
    this.curid = curid;
    let hash = this.$route.params.access;
    // this.getGrant(curid)
    let access = 0;
    if (hash) {
      access = hash.charAt(3)
    }
    this.getDownload();
    this._getOne(curid, access);

  },
  methods: {
    ...mapMutations(['updateUserInfo']),
    getDownload() {
      if (!this.userInfo || !this.userInfo.id) {
        return
      }
      this.$api.userApi.getIsDownload().then(res => {
        if (res.code == 0) {
          let cookieUser = this.$utils.getCookie("login");
          if (cookieUser) { cookieUser = JSON.parse(cookieUser) }
          if (!cookieUser || !cookieUser.id) {
            return
          } else {
            if (cookieUser.permissions == res.data) return;
            let obj = {
              ...cookieUser,
              permissions: res.data
            }
            this.updateUserInfo(obj);
            this.$utils.setCookie("login", JSON.stringify(obj), 30)
            this.$utils.setSession("lastLoginTime", new Date().getTime())
          }
        }
      })
    },
    addRecord(id, category) {
      let params = {
        banner: "节目",
        type: this.detailOne.type_id,
        id,
        category,
      }
      if (this.userInfo && this.userInfo.id) {
        params.user_id = this.userInfo.id
      }
      this.$api.recordApi.recordApis(params);
    },

    getGrant(curid) {
      let user_id = this.userInfo && this.userInfo.id ? this.userInfo.id : 0
      let params = {
        user_id: user_id,
        show_id: curid,
        ip: window.ip
      }
      this.$api.jmkApi.getGrantInfo(params).then(res => {
        this.loading = false;
        if (res.code == 1) {
          this.noRight = true
          this.errorMsg = res.msg;

        } if (res.code == 0) {
          this._getOne(curid);
        }
      })
    },

    async _getOne(id, no_access) {
      let user_id = this.userInfo && this.userInfo.id ? this.userInfo.id : 0
      const res = await this.$api.jmkApi.getOneById({
        id: id,
        user_id: user_id,
        ip: window.ip,
        no_access: no_access
      })
      if (res.grant != '已授权') {
        this.noRight = true
      }
      this.loading = false;
      this.showpath = res.showpath;
      let dataOne = res.data;
      dataOne.keywords = this.$utils.splitWord(dataOne.keywords);
      dataOne.cover_img = dataOne.cover_img ? this.setImage(this.showpath, dataOne.cover_img, ``) : ''
      
      dataOne.mp3_path = dataOne.mp3_path ? this.showpath + dataOne.mp3_path : ''
      
      if (dataOne.mp4_path) {
        this.hasVideo = true
        this.videoLoading = true
        dataOne.mp4_path = this.showpath + dataOne.mp4_path
      } else {
        this.hasVideo = false
        this.videoLoading = false
        dataOne.mp4_path = ''
      }
      // this.setVideoPath(dataOne.mp4_path)
      // dataOne.mp4_path = ''

      this.detailOne = dataOne;
      if (this.hasVideo) { this.curSourceType = '视频' }
      else if (dataOne.pic_list) {
        this.curSourceType = '图集'
      } else if (dataOne.mp3_path) {
        this.curSourceType = '音频'
      } else {
        this.curSourceType = '封面'
      }
      this._getOneOtherInfo(id);
      if (res.literature_goods && res.literature_goods.length) {
        this.literatures = res.literature_goods.map(v => {
          const row = this.literatureColum.find(vv => vv.id == v.category) || {}
          return {
            ...v,
            typeName: row.name
          }
        })
      }
      if (res.goodshowlist.length > 0) {
        this.relateType = 0;
      }
      if (res.goodshowlist.length == 0 && res.awardlist.length > 0) {
        this.relateType = 1;
      }
      if (res.goodshowlist.length == 0 && res.awardlist.length == 0 && res.activitylist.length > 0) {
        this.relateType = 2;
      }
      let picList = []
      if (res.data.pic_list) {
        try {
          picList = res.data.pic_list.split(",")
        } catch (err) { }
      }

      this.detailPicList = picList.map(v => {
        return {
          src: this.setImage(this.showpath, v, ``),
          thumb: this.setImage(this.showpath, v, ``)
        }
      })
      let list = res.goodshowlist || []
      list = await Promise.all(
        list.map(async (v) => {
          return {
            ...v,
            cover_img: this.setImage(res.showpath, v.cover_img, ``),
            thumbs: v.cover_img ? res.showpath + v.cover_img : ''
          };
        })
      );
      this.relateProgramlist = list
      this.relateAwardList = res.awardlist;
      let acList = res.activitylist || []
      acList = await Promise.all(
        acList.map(async (v) => {
          return {
            ...v,
            cover_img: this.setImage(res.showpath, v.cover_img, ``),
            thumbs: v.cover_img ? res.showpath + v.cover_img : ''
          };
        })
      );
      this.relateActivitylist = acList
      // setTimeout(() => {
      //   this._initGallery()
      // }, 50);

    },
    setVideoPath(src) {
      download.downloadBatch(src, (res) => {
        var videoBlob = new Blob([res], { type: 'video/mp4' });
        var videoUrl = URL.createObjectURL(videoBlob);
          
        var videoElement = document.getElementById('myVideo');
        videoElement.src = videoUrl;
        videoElement.controls = true;
        this.videoLoading = false
        
        // 当不再需要这个URL的时候，应该释放它
        setTimeout(() => {
          URL.revokeObjectURL(videoUrl);
        }, 300)
      })
    },
    async getSecondLabel(obj) {
      let type_tag = this.detailOne.type_tag
      let type_tags = []
      if (type_tag) {
        type_tags = type_tag.split(",")
      }
      let res1 = await this.$api.channelApi.getChannel({ parentId: obj.labelid })
      let list = res1.data
      let newFun = [], allSelect = []
      list.map(t => { newFun.push(this.$api.channelApi.getChannel({ parentId: t.id })) })
      let res2 = await Promise.all([...newFun])
      res2.map((t, i) => { list[i].children = t.data })
      list.map(t => {
        t.children.map(t2 => {
          type_tags.map(t3 => {
            if (t3 == t2.id) {
              t2.choosed = true; t.choosed = true
            }
          })
        })
      })
      list.map((t, i) => {
        let subArr = []
        t.children.map(t2 => {
          if (t2.choosed) {
            subArr.push(t2.name)
          }
        })
        if (t.choosed) { allSelect.push({ name: t.name, children: subArr.join("、") }) }
      })
      // console.log(list)
      console.log(allSelect)
      this.mulTypeTag = allSelect
    },

    //获取节目侧边演员信息
    _getOneOtherInfo(id) {
      this.$api.jmkApi.getOneOtherInfo({ id: id }).then(res => {
        let list = res.data;
        let newsList = this.$utils.mergeAttribute(list, 'artist_typename', "artist_name", "artist_id")
        this.otherInfo = newsList;
      })
    },

    // 切换资源分类  视频、图集、音频
    changeSourceType(type) {
      if (this.curSourceType == type) {
        return;
      }
      this.curSourceType = type;
      try {
        if (this.curSourceType != '视频') {
          document.getElementById("myVideo").pause()
        }
        if (this.curSourceType != '音频') {
          this.stopAudio()
        }
      } catch (err) { }

    },

    //隐藏侧边信息
    hideInfo() {
      this.slideUnfold = !this.slideUnfold;
      this.$refs.gallery && this.$refs.gallery.updateSwiper()
    },
    //切换相关内容
    changeRelateType(index) {
      if (index == this.relateType) {
        return;
      }
      this.relateType = index
    },

    //人才
    goArtist(id) {
      this.$router.push({
        path: "/artist/" + id
      })
    },
    toLiterature(id) {
      const hash = this.$utils.hashNum(0)
      this.$router.push({
        path: "/literature/" + id + '/' + hash
      })
    },

    download(fileSource, fileName) {
      // this.downZip()
      // return;
      this.addRecord(this.curid, 2)
      if (fileSource) {
        window.open(fileSource)
        return;
        let source = fileSource.split(".")
        let type = source[source.length - 1]

        var file = new File([fileSource], {
          type: "text/plain;charset=utf-8"
        })
        saveAs(file, fileName + "." + type)

      }
    },
    async downZip() {
      let data = [], mp4Source = {}, mp3Source = {}, picSource = [];
      let name = this.detailOne.name;
      if (this.detailOne.mp4_path) {
        mp4Source = {
          url: this.showpath + this.detailOne.mp4_path,
          file_name: name + '.mp4'
        }
        data.push(mp4Source)
      }
      if (this.detailOne.mp3_path) {
        mp3Source = {
          url: this.showpath + this.detailOne.mp3_path,
          file_name: name + ".mp3"
        }
        data.push(mp3Source)
      }
      if (this.detailOne.pic_list) {
        for (var i = 0; i < this.detailPicList.length; i++) {
          let hzs = this.detailPicList.split(".")
          let hz = hzs[hzs.length - 1]
          picSource.push({
            url: this.detailPicList[i],
            fileName: name + i + "." + hz
          })
        }

        data.push(picSource)
      }
      await downloadZip.handleBatchDownload(data)
    },



    // 跳转活动详情页
    goActivity(id) {
      this.$router.push({
        path: "/activity/" + id
      })
    },
    //音频播放与暂停事件
    changeAudioState() {
      if (this.audioPlay) {
        this.stopAudio()
      } else {
        this.playAudio()
      }
    },
    // 停止音频
    stopAudio() {
      document.getElementById("bgm").pause();
      this.audioPlay = false;
    },
    // 播放音频
    playAudio() {
      document.getElementById("bgm").play();
      this.audioPlay = true;
    },
    audioChange() {

    },

    updateTime() {
      let music = document.getElementById("bgm");
      this.audioDuration = music.duration;
      this.audioCurrentTime = music.currentTime;
    },

    changeAudio111(e) {
      // console.log(e);
      let music = document.getElementById("bgm");
      let width = this.$refs.audioWidto.clientWidth
      let left = e.offsetX
      let percent = (left / width).toFixed(4)
      music.currentTime = music.duration * percent
    },
    changeAudio(e) {
      let music = document.getElementById("bgm");
      let percent = e.target.value
      console.log(percent);
      music.currentTime = music.duration * (percent / 100)

    },
    audioCanPlay(e) {
      let music = document.getElementById("bgm");
      this.audioDuration = music.duration;
    }


  }
}
</script>
<style lang="scss" scoped>
@import url(~@/assets/css/range.css);

.program-detail-content {
  .introduce .title {
    /deep/ .actions {
      font-size: 12px;
      font-weight: normal;
      display: inline-flex;
      margin-left: 30px;

      .item {
        position: relative;

        &::before {
          content: "";
          position: absolute;
          width: 2px;
          height: 2px;
          background: #ccc;
          border-radius: 100%;
          left: -12px;
          top: 40%;
        }

      }
    }
  }
}

.cl-red {
  color: #B41717;
  cursor: pointer;
}
</style>